/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CSSObject } from "styled-components";
import { SVGIcon, Tooltip } from "@nordcloud/gnui";

type Props = {
  url: string;
  caption: string;
  css?: CSSObject;
};

export function ExternalLinkWithIndicator({ url, caption, css = {} }: Props) {
  return (
    <div
      data-testid="externalLink"
      css={Object.assign(
        {
          position: "relative",
          display: "inline-flex",
          marginLeft: ".5rem",
        },
        css
      )}
    >
      <Tooltip caption={caption} hideTimeout={0} minWidth="max-content">
        <ExternalLink
          css={{
            display: "flex",
            color: "currentColor",
          }}
          href={url}
        >
          <SVGIcon
            name="externalLink"
            size="sm"
            css={{
              fill: "currentColor",
            }}
          />
        </ExternalLink>
      </Tooltip>
    </div>
  );
}

export function ExternalLink({
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a rel="noreferrer" target="_blank" {...props}>
      {children}
    </a>
  );
}
